// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  padding: 6px 15px !important;
  border-radius: 8px 8px 0px 0px;
  background-color: var(--app-surface);
  border-bottom: solid 0.75px var(--app-legacy-card-divider);
}

.modal-header-content {
  flex: 1 1 auto;
  min-width: 0;
}

.modal-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-close-button {
  flex: 0 0 auto;
  font-size: var(--app-font-size-20px);
  line-height: 1;
}

.modal-body {
  min-height: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--app-ink-alpha-250) transparent;
  padding: 6px 15px !important;
}

.modal-body.has-floating-elements {
  padding-bottom: 75px !important;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-height: auto !important;
  padding: 6px 15px !important;
  border-radius: 0px 0px 8px 8px;
  background-color: var(--app-surface);
}

.modal-footer > * {
  margin: 0;
}

.mat-mdc-dialog-surface {
  border-radius: 8px !important;
}

.floating-bar {
  position: absolute;
  bottom: 65px;
  left: 0;
  right: 0;
  min-height: 56px;
  background-color: var(--app-surface);
  z-index: 10;
  transition: bottom 0.5s ease-in-out;
  margin: 0 1.5rem;
  padding: 0;
  border-radius: 6px;
}

.modal-confirm-label-mobile {
  display: none;
}

@media (max-width: 640px) {
  .modal-confirm-label-desktop {
    display: none;
  }

  .modal-confirm-label-mobile {
    display: inline;
  }
}

:host { display: flex; flex-direction: column; min-height: var(--app-dialog-min-height, 20dvh); max-height: var(--app-dialog-max-height, 85dvh); }
.modal-header { border-top: 2px solid var(--app-primary) !important; flex-shrink: 0; }
.modal-close-button { color: var(--app-primary); }
.modal-body { flex: 1 1 auto; min-height: 0; max-height: none; overflow: auto; }
.modal-footer { flex-shrink: 0; }
.floating-bar { border-top: 1.5px solid var(--app-primary); }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modal/modal.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,QAAQ,aAAa,EAAE,sBAAsB,EAAE,+CAA+C,EAAE,+CAA+C,EAAE;AACjJ,gBAAgB,mDAAmD,EAAE,cAAc,EAAE;AACrF,sBAAsB,yBAAyB,EAAE;AACjD,cAAc,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC/E,gBAAgB,cAAc,EAAE;AAChC,gBAAgB,0CAA0C,EAAE","sourcesContent":[".modal-header {\n  padding: 6px 15px !important;\n  border-radius: 8px 8px 0px 0px;\n  background-color: var(--app-surface);\n  border-bottom: solid 0.75px var(--app-legacy-card-divider);\n}\n\n.modal-header-content {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.modal-title {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.modal-close-button {\n  flex: 0 0 auto;\n  font-size: var(--app-font-size-20px);\n  line-height: 1;\n}\n\n.modal-body {\n  min-height: auto;\n  scrollbar-width: thin;\n  scrollbar-color: var(--app-ink-alpha-250) transparent;\n  padding: 6px 15px !important;\n}\n\n.modal-body.has-floating-elements {\n  padding-bottom: 75px !important;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  min-height: auto !important;\n  padding: 6px 15px !important;\n  border-radius: 0px 0px 8px 8px;\n  background-color: var(--app-surface);\n}\n\n.modal-footer > * {\n  margin: 0;\n}\n\n.mat-mdc-dialog-surface {\n  border-radius: 8px !important;\n}\n\n.floating-bar {\n  position: absolute;\n  bottom: 65px;\n  left: 0;\n  right: 0;\n  min-height: 56px;\n  background-color: var(--app-surface);\n  z-index: 10;\n  transition: bottom 0.5s ease-in-out;\n  margin: 0 1.5rem;\n  padding: 0;\n  border-radius: 6px;\n}\n\n.modal-confirm-label-mobile {\n  display: none;\n}\n\n@media (max-width: 640px) {\n  .modal-confirm-label-desktop {\n    display: none;\n  }\n\n  .modal-confirm-label-mobile {\n    display: inline;\n  }\n}\n\n:host { display: flex; flex-direction: column; min-height: var(--app-dialog-min-height, 20dvh); max-height: var(--app-dialog-max-height, 85dvh); }\n.modal-header { border-top: 2px solid var(--app-primary) !important; flex-shrink: 0; }\n.modal-close-button { color: var(--app-primary); }\n.modal-body { flex: 1 1 auto; min-height: 0; max-height: none; overflow: auto; }\n.modal-footer { flex-shrink: 0; }\n.floating-bar { border-top: 1.5px solid var(--app-primary); }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
